import { useEffect, useState } from "react";
import { toCurrency } from "@heartinz/finance";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import InterRegular from "./font/Inter_24pt-Regular-normal";
import InterBold from "./font/Inter_24pt-Bold-normal";
import QRCode from "qrcode";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import uRLs from "../../../utils/baseUtils";
import { CircularProgress } from "@mui/material";
import { useContextApi } from "../../../context/ContextApi";
import { CheckIcon, CloseIcon, DownloadIcon, EditIcon, PrinterIcon } from "../../../constants/Icons";
// const data= {
//         "preSaleData": {
//             "_id": "6a68504e908d6e6822631c72",
//             "storeId": "67e0e9ca808c79951a263e50",
//             "mainStoreId": "67e0e9ca808c79951a263e50",
//             "billingStoreProfileId": "67e0e9ca808c79951a263e52",
//             "billingStoreProfile": {
//                 "_id": "67e0e9ca808c79951a263e52",
//                 "storeid": "67e0e9ca808c79951a263e50",
//                 "title": "HEARTINZ TECHNOLOGIES PRIVATE LIMITED",
//                 "email": "support@heartinz.com",
//                 "state": "Kerala",
//                 "statecode": "32",
//                 "gstnumber": "29ABCDE1234F1Z5",
//                 "phone": "7708343523",
//                 "district": "Coimbatore",
//                 "pincode": "641001",
//                 "country": "INDIA",
//                 "image": "F2vyjPEbM3dTfq0HOqXvKyxnwSjB0LCb.png",
//                 "addressline1": "111",
//                 "addressline2": "R G St",
//                 "pannumber": "",
//                 "cinnumber": "L72501TZ2019PTC032641",
//                 "fssai": "66774747474574"
//             },
//             "preSaleByStoreId": "67e0e9ca808c79951a263e50",
//             "preSaleNo": "PRF2627-10",
//             "preSaleUTCDate": "2026-07-27T18:30:00.000Z",
//             "preSaleMode": "PROFORMA_INVOICE",
//             "preSaleType": "B2C",
//             "preSaleItems": [
//                 {
//                     "_id": "69e868841ffbc70656fbbe05",
//                     "code": "2604221880",
//                     "hsnsac": "85371000",
//                     "title": "KALINGA 3PHASE FN63 METER BOX",
//                     "note": "",
//                     "mrp": 740001,
//                     "saleprice": 596200,
//                     "soldprice": 596201,
//                     "taxpercentage": 18,
//                     "baseprice": 505255,
//                     "isLock": "SALEPRICE",
//                     "isStock": false,
//                     "quantity": 1,
//                     "imode": "PRODUCT",
//                     "itemNo": 1,
//                     "discount": 143800,
//                     "taxamount": 90946,
//                     "sgstPercent": "9",
//                     "sgstAmount": 45473,
//                     "cgstPercent": "9",
//                     "cgstAmount": 45473,
//                     "igstPercent": "18",
//                     "igstAmount": 90946,
//                     "lineTotalMrp": 740001,
//                     "lineTotalSalePrice": 596200,
//                     "lineTotalSoldPrice": 596201,
//                     "lineTotalDiscount": 143800,
//                     "lineTotalBasePrice": 505255,
//                     "lineTotalTaxAmount": 90946,
//                     "lineTotalSgstAmount": 45473,
//                     "lineTotalCgstAmount": 45473,
//                     "lineTotalIgstAmount": 90946,
//                     "lineGrandTotal": 596201
//                 },
//                 {
//                     "_id": "6a452c18d97c7eac6e7c3bae",
//                     "code": "26070148",
//                     "hsnsac": "76071991",
//                     "title": "B1 - Aluminium Foil Roll 25m",
//                     "note": "Exchange Only with Bill",
//                     "mrp": 18000,
//                     "saleprice": 17000,
//                     "soldprice": 17000,
//                     "taxpercentage": 5,
//                     "baseprice": 16190,
//                     "isLock": "SALEPRICE",
//                     "isStock": true,
//                     "quantity": 10000,
//                     "imode": "PRODUCT",
//                     "unitConfig": {
//                         "primaryUnitCode": "roll",
//                         "stockScale": 10000
//                     },
//                     "isSecondaryUnit": false,
//                     "itemNo": 2,
//                     "discount": 1000,
//                     "taxamount": 810,
//                     "sgstPercent": "2.5",
//                     "sgstAmount": 405,
//                     "cgstPercent": "2.5",
//                     "cgstAmount": 405,
//                     "igstPercent": "5",
//                     "igstAmount": 810,
//                     "lineTotalMrp": 18000,
//                     "lineTotalSalePrice": 17000,
//                     "lineTotalSoldPrice": 17000,
//                     "lineTotalDiscount": 1000,
//                     "lineTotalBasePrice": 16190,
//                     "lineTotalTaxAmount": 810,
//                     "lineTotalSgstAmount": 405,
//                     "lineTotalCgstAmount": 405,
//                     "lineTotalIgstAmount": 810,
//                     "lineGrandTotal": 17000
//                 },
//                 {
//                     "_id": "6a454c5fd97c7eac6e7c6740",
//                     "code": "26070181",
//                     "hsnsac": "44191100",
//                     "title": "B1 - Bamboo Cutting Board",
//                     "note": "Warranty Void if Seal Broken",
//                     "mrp": 45000,
//                     "saleprice": 42000,
//                     "soldprice": 42000,
//                     "taxpercentage": 18,
//                     "baseprice": 35593,
//                     "isLock": "SALEPRICE",
//                     "isStock": true,
//                     "quantity": 10000,
//                     "imode": "PRODUCT",
//                     "unitConfig": {
//                         "primaryUnitCode": "pcs",
//                         "stockScale": 10000
//                     },
//                     "isSecondaryUnit": false,
//                     "itemNo": 3,
//                     "discount": 3000,
//                     "taxamount": 6407,
//                     "sgstPercent": "9",
//                     "sgstAmount": 3203,
//                     "cgstPercent": "9",
//                     "cgstAmount": 3203,
//                     "igstPercent": "18",
//                     "igstAmount": 6407,
//                     "lineTotalMrp": 45000,
//                     "lineTotalSalePrice": 42000,
//                     "lineTotalSoldPrice": 42000,
//                     "lineTotalDiscount": 3000,
//                     "lineTotalBasePrice": 35593,
//                     "lineTotalTaxAmount": 6407,
//                     "lineTotalSgstAmount": 3203,
//                     "lineTotalCgstAmount": 3203,
//                     "lineTotalIgstAmount": 6407,
//                     "lineGrandTotal": 42000
//                 },
//                 {
//                     "_id": "6a451dd3d97c7eac6e7c23fc",
//                     "code": "26070129",
//                     "hsnsac": "33042000",
//                     "title": "B1 - Maybelline Kajal",
//                     "note": "Return Not Accepted on Discounted Items",
//                     "mrp": 24900,
//                     "saleprice": 22500,
//                     "soldprice": 22500,
//                     "taxpercentage": 5,
//                     "baseprice": 21429,
//                     "isLock": "SALEPRICE",
//                     "isStock": false,
//                     "quantity": 10000,
//                     "imode": "PRODUCT",
//                     "unitConfig": {
//                         "primaryUnitCode": "pcs",
//                         "stockScale": 10000
//                     },
//                     "isSecondaryUnit": false,
//                     "itemNo": 4,
//                     "discount": 2400,
//                     "taxamount": 1071,
//                     "sgstPercent": "2.5",
//                     "sgstAmount": 535,
//                     "cgstPercent": "2.5",
//                     "cgstAmount": 535,
//                     "igstPercent": "5",
//                     "igstAmount": 1071,
//                     "lineTotalMrp": 24900,
//                     "lineTotalSalePrice": 22500,
//                     "lineTotalSoldPrice": 22500,
//                     "lineTotalDiscount": 2400,
//                     "lineTotalBasePrice": 21429,
//                     "lineTotalTaxAmount": 1071,
//                     "lineTotalSgstAmount": 535,
//                     "lineTotalCgstAmount": 535,
//                     "lineTotalIgstAmount": 1071,
//                     "lineGrandTotal": 22500
//                 },
//                 {
//                     "serviceId": "6a1e89586593685d1dda05a1",
//                     "title": "Waiting Charge",
//                     "hsnsac": "998765",
//                     "description": "",
//                     "mrp": 15000,
//                     "saleprice": 13000,
//                     "soldprice": 13000,
//                     "taxpercentage": 18,
//                     "baseprice": 11017,
//                     "isLock": "SALEPRICE",
//                     "isStock": false,
//                     "quantity": 15000,
//                     "serviceByName": "Kumar",
//                     "imode": "SERVICE",
//                     "unitConfig": {
//                         "primaryUnitCode": "hr",
//                         "stockScale": 10000
//                     },
//                     "itemNo": 5,
//                     "discount": 2000,
//                     "taxamount": 1983,
//                     "sgstPercent": "9",
//                     "sgstAmount": 991,
//                     "cgstPercent": "9",
//                     "cgstAmount": 991,
//                     "igstPercent": "18",
//                     "igstAmount": 1983,
//                     "lineTotalMrp": 22500,
//                     "lineTotalSalePrice": 19500,
//                     "lineTotalSoldPrice": 19500,
//                     "lineTotalDiscount": 3000,
//                     "lineTotalBasePrice": 16525,
//                     "lineTotalTaxAmount": 2975,
//                     "lineTotalSgstAmount": 1487,
//                     "lineTotalCgstAmount": 1487,
//                     "lineTotalIgstAmount": 2975,
//                     "lineGrandTotal": 19500
//                 },
//                 {
//                     "walletid": "6876943ad5092f4f6bf44ca6",
//                     "operator": "Sun Direct",
//                     "number": "9383838883",
//                     "title": "Recharge - Sun Direct - 9383838883",
//                     "description": "Test L",
//                     "hsnsac": null,
//                     "mrp": 19900,
//                     "saleprice": 19900,
//                     "soldprice": 19900,
//                     "taxpercentage": 0,
//                     "baseprice": 19900,
//                     "isLock": "SALEPRICE",
//                     "isStock": false,
//                     "quantity": 1,
//                     "imode": "RECHARGE",
//                     "itemNo": 6,
//                     "discount": 0,
//                     "taxamount": 0,
//                     "sgstPercent": "0",
//                     "sgstAmount": 0,
//                     "cgstPercent": "0",
//                     "cgstAmount": 0,
//                     "igstPercent": "0",
//                     "igstAmount": 0,
//                     "lineTotalMrp": 19900,
//                     "lineTotalSalePrice": 19900,
//                     "lineTotalSoldPrice": 19900,
//                     "lineTotalDiscount": 0,
//                     "lineTotalBasePrice": 19900,
//                     "lineTotalTaxAmount": 0,
//                     "lineTotalSgstAmount": 0,
//                     "lineTotalCgstAmount": 0,
//                     "lineTotalIgstAmount": 0,
//                     "lineGrandTotal": 19900
//                 },
//                 {
//                     "serviceId": "6a2fec2983cbd76ba5ad5f06",
//                     "title": "AC General Service",
//                     "hsnsac": null,
//                     "description": "",
//                     "mrp": 60000,
//                     "saleprice": 60000,
//                     "soldprice": 60000,
//                     "taxpercentage": 18,
//                     "baseprice": 50847,
//                     "isLock": "SALEPRICE",
//                     "isStock": false,
//                     "quantity": 10000,
//                     "serviceByName": "",
//                     "imode": "SERVICE",
//                     "unitConfig": {
//                         "primaryUnitCode": "unit",
//                         "stockScale": 10000
//                     },
//                     "itemNo": 7,
//                     "discount": 0,
//                     "taxamount": 9153,
//                     "sgstPercent": "9",
//                     "sgstAmount": 4576,
//                     "cgstPercent": "9",
//                     "cgstAmount": 4576,
//                     "igstPercent": "18",
//                     "igstAmount": 9153,
//                     "lineTotalMrp": 60000,
//                     "lineTotalSalePrice": 60000,
//                     "lineTotalSoldPrice": 60000,
//                     "lineTotalDiscount": 0,
//                     "lineTotalBasePrice": 50847,
//                     "lineTotalTaxAmount": 9153,
//                     "lineTotalSgstAmount": 4576,
//                     "lineTotalCgstAmount": 4576,
//                     "lineTotalIgstAmount": 9153,
//                     "lineGrandTotal": 60000
//                 },
//                 {
//                     "_id": "69b7a9753a74a42ca750682c",
//                     "code": "2603165",
//                     "hsnsac": "8536",
//                     "title": "ABB 6A MCB SP",
//                     "note": "",
//                     "mrp": 14500,
//                     "saleprice": 14500,
//                     "soldprice": 14500,
//                     "taxpercentage": 18,
//                     "baseprice": 12288,
//                     "isLock": "SALEPRICE",
//                     "isStock": false,
//                     "quantity": 6,
//                     "imode": "PRODUCT",
//                     "itemNo": 8,
//                     "discount": 0,
//                     "taxamount": 2212,
//                     "sgstPercent": "9",
//                     "sgstAmount": 1106,
//                     "cgstPercent": "9",
//                     "cgstAmount": 1106,
//                     "igstPercent": "18",
//                     "igstAmount": 2212,
//                     "lineTotalMrp": 87000,
//                     "lineTotalSalePrice": 87000,
//                     "lineTotalSoldPrice": 87000,
//                     "lineTotalDiscount": 0,
//                     "lineTotalBasePrice": 73729,
//                     "lineTotalTaxAmount": 13271,
//                     "lineTotalSgstAmount": 6635,
//                     "lineTotalCgstAmount": 6635,
//                     "lineTotalIgstAmount": 13271,
//                     "lineGrandTotal": 87000
//                 }
//             ],
//             "totalItems": 8,
//             "totalMrp": 1017301,
//             "totalSalePrice": 864100,
//             "totalSoldPrice": 864101,
//             "totalBasePrice": 739468,
//             "totalDiscount": 153200,
//             "totalTaxAmount": 124633,
//             "sgstAmount": 62316,
//             "cgstAmount": 62316,
//             "igstAmount": 124633,
//             "taxType": "CGST_SGST",
//             "grandTotal": 864100,
//             "status": "ACTIVE",
//             "preSaleTrack": "ADDED",
//             "preSaleVersion": 1,
//             "createdAt": "2026-07-28T06:46:38.175Z",
//             "updatedAt": "2026-07-28T06:52:44.809Z",
//             "__v": 0,
//             "amountInWords": "Eight Thousand Six Hundred Forty One Rupees Only",
//             "customerId": "69a00fff7b6270947343f816",
//             "lastItemNo": 8,
//             "preSaleTo": {
//                 "shippingAddress": {
//                     "addressline1": "",
//                     "addressline2": "",
//                     "state": "",
//                     "district": "",
//                     "city": "",
//                     "country": "",
//                     "pincode": ""
//                 },
//                 "contactPerson": {
//                     "name": "",
//                     "number": "9447389356"
//                 },
//                 "_id": "69a00fff7b6270947343f816",
//                 "name": "KAILAS AGENCIES",
//                 "nickname": "",
//                 "phone": "9447389356",
//                 "email": "",
//                 "addressline1": "SREE KRISHNAMURARI TEMPLE JUNCTION",
//                 "addressline2": "KAITHAMUKKU,THIRUVANANTHAPURAM",
//                 "state": null,
//                 "statecode": null,
//                 "district": "",
//                 "country": "",
//                 "pincode": "",
//                 "gstnumber": "",
//                 "pannumber": "",
//                 "isPayLater": false,
//                 "tradeName": "",
//                 "website": "",
//                 "bulkHistoryId": "69a00fff7b6270947343f7eb",
//                 "bulkHistoryCustomerNo": 42
//             },
//             "projectId": "6a3f722545f772827fd47c31"
//         }
//     }

const InvoiceTemp = ({data, onClose,onEdit, onDone }) => {
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState("");
  const [download, setDownload] = useState(false);
  const {useEscapeKey}=useContextApi();
  const saleMode = data?.preSaleData?.preSaleMode?.toUpperCase();
  const isProforma = saleMode 
  === "PROFORMA_INVOICE";
  const isQuotation = saleMode === "QUOTATION";
  const title = isProforma
    ? "PROFORMA INVOICE"
    : isQuotation
      ? "QUOTATION"
      : "ESTIMATION";

  const NumberLabel = isProforma
  ? "Proforma No :"
  : isQuotation
    ? "Quotation No :"
    : "Estimation No :";

 const NumVal = isProforma
  ? data?.preSaleData?.preSaleNo
  : isQuotation
    ? data?.quotationNo
    : data?.estimateNo;

  const isDate= data?.estimateDate || data?.preSaleData?.createdAt ||data?.quotationItems;
  const tableData=data?.estimateItems ||data?.preSaleData?.preSaleItems || data?.quotationItems
  useEscapeKey(onClose);
  const handleClose = () => {
    onClose();
  };
 
  const handleEdit=(data)=>{
    onEdit(data)
  }
  // console.log("hai",data)
  const loadImageDimensions = (base64Src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () =>
        resolve({ width: img.naturalWidth, height: img.naturalHeight });
      img.onerror = reject;
      img.src = base64Src;
    });
  };
  let cachedProfileImageBase64 = null;
  const generateEstimationPDF = async () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const padding = 4;
    const headerX = 7;
    const headerY = 7;
    const headerWidth = 196;
    const headerHeight = 45;
    const cleanMultiline = (str) =>
      str
        .replace(/\t/g, "    ") // Replace tab with 4 spaces (preserve indentation)
        .replace(/\r\n|\r/g, "\n") // Normalize all line breaks
        .trim();
    doc.setFillColor(245, 245, 245);
    doc.roundedRect(headerX, headerY, headerWidth, headerHeight, 4, 4, "F");
    const imagePath = uRLs.IMAGE_URL + "profile/" + data?.estimateFromId?.image;
    let imgHeight = 10;

    if (data?.estimateFromId?.image) {
      try {
        // Only fetch and convert image once
        if (!cachedProfileImageBase64) {
          const response = await fetch(imagePath);
          const blob = await response.blob();
          cachedProfileImageBase64 = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });
        }

        // Load dimensions and resize proportionally
        const { width: naturalWidth, height: naturalHeight } =
          await loadImageDimensions(cachedProfileImageBase64);

        const maxWidth = 50;
        const maxHeight = 10;
        let imgWidth = naturalWidth;
        let imgHeight = naturalHeight;

        const widthRatio = maxWidth / imgWidth;
        const heightRatio = maxHeight / imgHeight;
        const ratio = Math.min(widthRatio, heightRatio);

        imgWidth *= ratio;
        imgHeight *= ratio;

        // Add the cached image
        doc.addImage(
          cachedProfileImageBase64,
          "JPEG",
          headerX + padding,
          headerY + padding,
          imgWidth,
          imgHeight
        );
      } catch (err) {
        console.warn("Image failed to load:", err);
      }
    }  
    doc.setFontSize(20);
    doc.setTextColor(71, 69, 67);
    doc.setFont("Inter-Bold", "bold");
    const rightPadding = 10;
    const titleWidth = doc.getTextWidth(title);
    const x = pageWidth - rightPadding - titleWidth;
    doc.text(title,x, headerY + 12);
    let textY = headerY + (imgHeight || 0) + padding + 2;
    textY += 4;
    doc.setFontSize(9);
    doc.setTextColor(0);
    doc.setFont("Inter-Bold", "bold");
    doc.text(
      String(data?.estimateFromId?.title || ""),
      headerX + padding,
      textY
    );
    textY += 5;
    const addressParts = [
      data?.estimateFromId?.addressline1,
      data?.estimateFromId?.addressline2,
      data?.estimateFromId?.state,
      data?.estimateFromId?.district,
      data?.estimateFromId?.country,
    ].filter(Boolean);

    const addressLine =
      addressParts.join(", ") +
      (data?.estimateFromId?.pincode
        ? ` - ${data.estimateFromId.pincode}`
        : "");
    doc.setFontSize(9);
    doc.setFont("Inter-Regular", "normal");
    const wrappedAddress = doc.splitTextToSize(addressLine, 90);
    wrappedAddress.forEach((line) => {
      doc.text(line, headerX + padding, textY);
      textY += 5;
    });
    doc.text(
      `Phone: ${data?.estimateFromId?.phone || ""}`,
      headerX + padding,
      textY
    );
    textY += 5;
    doc.text(
      `Email: ${data?.estimateFromId?.email || ""}`,
      headerX + padding,
      textY
    );
    textY += 5;
    const corporateId = data?.estimateFromId?.cin;
    if (corporateId) {
      doc.text(
        `Corporate Identity #: ${corporateId}`,
        headerX + padding,
        textY
      );
    }
    doc.setFont("Inter-Bold", "bold");
    doc.text(NumberLabel, pageWidth - 63, headerY + 30);
    doc.setFont("Inter-Regular", "normal");
    doc.text(NumVal, pageWidth - 24, headerY + 30, {
      align: "right",
    });
    doc.setFont("Inter-Bold", "bold");
    doc.text("Date:", pageWidth - 49, headerY + 35);
    doc.setFont("Inter-Regular", "normal");
    doc.text(
      `${
        DateConverter.ISOToDisplayFormat(
          DateConverter.convertToTimeZone(isDate)
        ).date
      }`,
      pageWidth - 20,
      headerY + 35,
      {
        align: "right",
      }
    );
    let y = headerY + headerHeight + 5;
     if (data?.estimateToId) {
    doc.setFontSize(9);
    doc.setFont("Inter-Bold", "bold");
    doc.text("Estimation To", 14, y);
    doc.setFontSize(9);
    doc.setFont("Inter-Regular", "normal");
    const labelX = 20;
    const colonX = 35;
    const startY = 67;
    const lineHeight = 5;
    y += 7; 
    const customerData = [
      ["Name", data?.estimateToId?.name || "-"],
      [
        "Address",
        [
          data.estimateToId?.addressline1,
          data.estimateToId?.addressline2,
          data.estimateToId?.district,
          data.estimateToId?.state,
          data.estimateToId?.country,
          data.estimateToId?.pincode,
        ]
          .filter(Boolean)
          .join(", "),
      ],
      ["Phone", data?.estimateToId?.phone || "-"],
      ["Email", data?.estimateToId?.email || "-"],
    ];
    // let y = startY;
    for (let i = 0; i < customerData.length; i++) {
      const [label, value] = customerData[i];

      doc.setFont("Inter-Regular", "normal");
      doc.text(label.padStart(8), labelX, y);

      if (label === "Name") {
        doc.setFont("Inter-Bold", "bold");
        doc.text(":  " + value, colonX, y);
        y += lineHeight;
      } else if (label === "Address") {
        const indent = "    ";
        const wrappedAddress = doc.splitTextToSize(value, 165);
        let currentY = y;
        doc.setFont("Inter-Regular", "normal");
        wrappedAddress.forEach((line, idx) => {
          const text = (idx === 0 ? ":  " : indent) + line;
          doc.text(text, colonX, currentY);
          currentY += lineHeight;
        });
        y = currentY;
      } else {
        doc.setFont("Inter-Regular", "normal");
        doc.text(":  " + value, colonX, y);
        y += lineHeight;
      }
    }
     y += 2;
  }
    const productRows = (tableData || []).map((product, index) => {
      const desc = [
        `${product?.title || ""} - ${cleanMultiline(
          product?.description || ""
        )}`,
        product?.hsnsac ? `HSN/SAC: ${product.hsnsac}` : null,
        `Quantity: ${product?.quantity || 0}`,
        `MRP     : ₹${CurrencyConverter.toCurrency(product?.mrp || 0, "INR")}`,
        `Discount: - ₹${CurrencyConverter.toCurrency(
          product?.discount || 0,
          "INR"
        )}`,
        `Price    : ₹${CurrencyConverter.toCurrency(
          product?.soldprice || 0,
          "INR"
        )}`,
        `TaxableValue   : ₹${CurrencyConverter.toCurrency(
          product?.lineTotalBasePrice || 0,
          "INR"
        )}`,
        `@${product?.taxpercentage}%`,
      ].join("\n");

      return [
        { content: index + 1, styles: { halign: "center" } },
        { content: desc, styles: { cellPadding: 3 } },
        {
          content: `₹${CurrencyConverter.toCurrency(
            product?.baseprice || 0,
            "INR"
          )}`,
          styles: { halign: "right" },
        },
      ];
    });
    const summaryRows = [
      [
        { content: "" },
        { content: "Total", styles: { fontStyle: "bold", halign: "right" } },
        {
          content: `₹${CurrencyConverter.toCurrency(
            data?.totalBasePrice || 0,
            "INR"
          )}`,
          styles: { halign: "right" },
        },
      ],
      [
        { content: "" },
        { content: "+GST", styles: { halign: "right" } },
        {
          content: `₹${CurrencyConverter.toCurrency(
            data?.totalTaxAmount || 0,
            "INR"
          )}`,
          styles: { halign: "right" },
        },
      ],
      [
        { content: "" },
        {
          content: "Total Amount",
          styles: { fontStyle: "bold", halign: "right" },
        },
        {
          content: `₹${CurrencyConverter.toCurrency(
            data?.grandTotal || 0,
            "INR"
          )}`,
          styles: { fontStyle: "bold", halign: "right" },
        },
      ],
    ];
    autoTable(doc, {
      startY: y + 1,
      head: [["S.No", "Description", "Amount"]],
      body: productRows,
      theme: "grid",
      styles: {
        font: "Inter-Regular",
        fontStyle: "normal",
        fontSize: 9,
        cellPadding: 2,
        overflow: "linebreak",
        valign: "middle",
        lineColor: [255, 255, 255],
        lineWidth: 0.5,
      },
      headStyles: {
        font: "Inter-Bold",
        fontStyle: "bold",
        fillColor: "#dbdbdb",
        textColor: [0, 0, 0],
        halign: "center",
      },
      columnStyles: {
        0: { cellWidth: 13, halign: "center" },
        1: { cellWidth: 142 },
        2: { cellWidth: 25, halign: "right" },
      },
      didParseCell: (data) => {
        if (data.section === "body") {
          data.cell.styles.fillColor = [245, 245, 245];
          data.cell.styles.textColor = [51, 51, 51];
        }
      },
    });
    const afterProductsY = doc.lastAutoTable.finalY;
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginBottom = 20;
    const estimatedSummaryHeight = 30;
    let summaryStartY;
    const hasEnoughSpace =
      afterProductsY + estimatedSummaryHeight + marginBottom <= pageHeight;
    if (hasEnoughSpace) {
      summaryStartY = afterProductsY;
    } else {
      doc.addPage();
      summaryStartY = 20;
    }
    autoTable(doc, {
      startY: summaryStartY,
      body: summaryRows,
      theme: "grid",
      showHead: "never",
      styles: {
        font: "Inter-Regular",
        fontSize: 9,
        cellPadding: 2,
        valign: "middle",
        lineColor: [255, 255, 255],
        lineWidth: 0.5,
      },
      columnStyles: {
        0: { cellWidth: 13 },
        1: { cellWidth: 142, halign: "right" },
        2: { cellWidth: 25, halign: "right" },
      },
      didParseCell: (data) => {
        const lastRowIndex = summaryRows.length - 1;
        if (data.section === "body") {
          if (data.row.index === lastRowIndex) {
            data.cell.styles.fillColor = "#dbdbdb";
            data.cell.styles.textColor = [0, 0, 0];
            data.cell.styles.font = "Inter-Bold";
            data.cell.styles.fontStyle = "bold";
          } else {
            data.cell.styles.fillColor = [245, 245, 245];
            data.cell.styles.textColor = [51, 51, 51];
            data.cell.styles.font = "Inter-Regular";
            data.cell.styles.fontStyle = "normal";
          }
        }
      },
    });
    let finalY = doc.lastAutoTable.finalY;
    doc.setFontSize(10);
    doc.setTextColor(0);
    doc.setFont("Inter-Bold", "bold");
    doc.text("Note:", 14, finalY + 10);
    doc.setFont("Inter-Regular", "normal");
    doc.text(
      "1. The Estimation is valid for 5 Days from the date of issue.",
      20,
      finalY + 15
    );
    const finalYBeforeSection = doc.lastAutoTable.finalY;
    const pageHeight2 = doc.internal.pageSize.getHeight();
    const sectionHeight = 45;
    const marginTop = 10;
    const marginBottom1 = 10;
    finalY = finalYBeforeSection;
    if (finalY + sectionHeight > pageHeight2 - marginBottom1) {
      doc.addPage();
      finalY = marginTop;
    } else {
      finalY += 15;
    }
    if(!isProforma){
    doc.setFontSize(9);
    doc.setFont("Inter-Bold", "bold");
    doc.setFillColor(245, 245, 245);
    doc.rect(13, finalY + 6, 110, 6, "F");
    doc.text("Payment Info", 14, finalY + 10);
 
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);
    const paymenyLabelX = 14;
    const valueX = 40;
    let paymenyLabelY = finalY + 15;
    const paymenyLineHeight = 5;
    const paymentSettings = data?.settings;

    const bankDetails = [
      ["Account Name", paymentSettings?.bankDetails?.beneficiaryName || ""],
      ["Account Number", paymentSettings?.bankDetails?.accountNo || ""],
      ["IFSC Code", paymentSettings?.bankDetails?.ifsc || ""],
      ["UPI ID", paymentSettings?.upiId || ""],
    ];
    bankDetails.forEach(([label, value]) => {
      const labelBgWidth = 26;
      const labelBgHeight = 6;
      const labelBgX = paymenyLabelX - 1;
      const labelBgY = paymenyLabelY - 4.5;
      doc.setFillColor(245, 245, 245);
      doc.rect(labelBgX, labelBgY, labelBgWidth, labelBgHeight, "F");
      doc.text(label, paymenyLabelX, paymenyLabelY);
      doc.text(value, valueX, paymenyLabelY);
      paymenyLabelY += paymenyLineHeight;
    });
    const upiId = paymentSettings?.upiId || "";
    const payeeName = paymentSettings?.bankDetails?.beneficiaryName || "";
    const upiUrl = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(
      payeeName
    )}&cu=INR`;
    if (data?.settings?.upiId.trim()) {
      const qrCodeDataUrl = await QRCode.toDataURL(upiUrl, {
        errorCorrectionLevel: "L",
        scale: 4,
        margin: 1,
      });
    
      const qrX = 130;
      const qrY = finalY + 3;
      const qrSize = 30;
    
      doc.addImage(qrCodeDataUrl, "JPEG", qrX, qrY, qrSize, qrSize);
   
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);
    doc.text("Scan to Pay", qrX + qrSize / 2, qrY + qrSize + 6, {
      align: "center",
    });
    const upiimage = "assets/images/invoice/newPaymentsUPI.png";
    doc.addImage(upiimage, "JPEG", qrX + qrSize + 5, qrY + 5, 0, 20);
    doc.setFontSize(10);
    doc.setTextColor(0);
    doc.setFont("Inter-Regular", "normal");
  }
}
    // doc.text("© 2024 Heartinz Technologies Pvt Ltd", 70, finalY + 50);
    setDownload(false);
    return doc;
  };
  const handleDownload = async () => {
    setDownload(true);
    const doc = await generateEstimationPDF();
    doc.save(`Estimation_${data?.estimateNo}.pdf`);
  };
  const handlePrint = async () => {
    const doc = await generateEstimationPDF();
    const blob = doc.output("blob");
    const blobUrl = URL.createObjectURL(blob);

    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    iframe.src = blobUrl;
    document.body.appendChild(iframe);
    iframe.onload = () => {
      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      }, 500);
    };
  };

  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS("Inter_24pt-Regular-normal.ttf", InterRegular);
        this.addFileToVFS("Inter_24pt-Bold-normal.ttf", InterBold);
        this.addFont(
          "Inter_24pt-Regular-normal.ttf",
          "Inter-Regular",
          "normal"
        );
        this.addFont("Inter_24pt-Bold-normal.ttf", "Inter-Bold", "bold");
      },
    ]);
  }, []);

  useEffect(() => {
    const upi = data?.settings?.upiId;
    const name = data?.settings?.bankDetails?.beneficiaryName;
    if (!upi) return; // skip until upi is available

    const upiUrl = `upi://pay?pa=${upi}&pn=${name}&cu=INR`;

    QRCode.toDataURL(upiUrl)
      .then((url) => {
        setQrCodeDataUrl(url);
      })
      .catch((err) => {
        console.error("QR Code generation failed: ", err);
      });
  }, [data?.settings?.upiId, data?.settings?.bankDetails?.beneficiaryName]);

  const imageSrc = uRLs.IMAGE_URL + "profile/" + data?.estimateFromId?.image;
  const [style, setStyle] = useState({
    width: "100px",
    height: "auto",
  });

  useEffect(() => {
    const load = async () => {
      try {
        const { width: naturalWidth, height: naturalHeight } =
          await loadImageDimensions(imageSrc);

        const maxWidth = 150;
        const maxHeight = 50;

        let imgWidth = naturalWidth;
        let imgHeight = naturalHeight;

        const widthRatio = maxWidth / imgWidth;
        const heightRatio = maxHeight / imgHeight;
        const ratio = Math.min(widthRatio, heightRatio);

        imgWidth = imgWidth * ratio;
        imgHeight = imgHeight * ratio;

        setStyle({
          width: `${imgWidth}px`,
          height: `${imgHeight}px`,
        });
      } catch (error) {
        console.error("Image load failed", error);
      }
    };

    load();
  }, [imageSrc]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "p") {
        event.preventDefault();
        handlePrint();
      }
    };
    const handleAfterPrint = () => {
      setTimeout(() => {
        window.focus();
      }, 100);
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("afterprint", handleAfterPrint);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("afterprint", handleAfterPrint);
    };
  }, []);

  return (
    <div className="modal-overlay">
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        id="CustomerModal"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-scrollable modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              {/* <h6 className="modal-title">{data.salemode}</h6> */}
              <button
                type="button"
                onClick={handleClose}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body" id="downloadable-content'">
              <div className="tm_container" id="element-to-print">
                <div className="tm_invoice_wrap">
                  <div className="tm_invoice tm_style1 tm_type1">
                    <div className="tm_invoice_in">
                      <table
                        width="100%"
                        className="pdfcontent "
                        style={{
                          borderRadius: "15px",
                          overflow: "hidden",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        <tbody>
                          <tr>
                            <td
                              width="70%"
                              style={{ textAlign: "left", padding: "1rem" }}
                            >
                              <div
                                className="tm_logo"
                                style={{
                                  position: "relative",
                                  ...style,
                                }}
                              >
                                <img
                                  src={imageSrc}
                                  alt="logo"
                                  style={{
                                    position: "absolute",
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                  className="img-rounded logo mb-0"
                                />
                              </div>
                            </td>

                            <td
                              width="30%"
                              style={{ textAlign: "center", padding: "1rem" }}
                            >
                              <span
                                className={`${isProforma?"font-18":"tm_f27"} tm_text_uppercase`}
                                style={{
                                  color: "#474543",
                                  fontStyle: "bold",
                                }}
                              >
                                {isProforma? "PROFORMA INVOICE" :"ESTIMATION"}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td width="70%" className="hederTd">
                              <p
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "600",
                                  marginBottom: "0px",
                                }}
                              >
                                {/* {data.customer?.name || ""} */}
                                {data?.estimateFromId?.title}
                              </p>
                              <div
                                style={{
                                  fontSize: "12px",
                                  lineHeight: "18px",
                                  marginBottom: "0px",
                                }}
                              >
                                <p className="mb-0">
                                  {[
                                    data?.estimateFromId?.addressline1,
                                    data?.estimateFromId?.addressline2,
                                    data?.estimateFromId?.state,
                                    data?.estimateFromId?.district,
                                    data?.estimateFromId?.country,
                                  ]
                                    .filter(Boolean)
                                    .join(", ")}
                                  {data?.estimateFromId?.pincode
                                    ? ` - ${data.estimateFromId.pincode}`
                                    : ""}
                                </p>
                                <p className="mb-0">
                                  {" "}
                                  Phone : {data?.estimateFromId?.phone}
                                  {/* {data.customer?.phone || ""} */}
                                </p>
                                <p className="mb-0">
                                  eMail : {data?.estimateFromId?.email}
                                  {/* {data.customer?.email || ""} */}
                                </p>
                                {data?.estimateFromId?.cin && (
                                  <p className="mb-0">
                                    Corporate Identity # :{" "}
                                    {data?.estimateFromId?.cin &&
                                      data?.estimateFromId?.cin}
                                    {/* {data.customer?.email || ""} */}
                                  </p>
                                )}
                              </div>
                            </td>
                            <td
                              width="30%"
                              className="hederTd"
                              style={{ textAlign: "center" }}
                            >
                              <p className="mb-0">
                                <span style={{ fontWeight: 600 }}>
                                  {" "}
                                  {NumberLabel}{" "}
                                </span>{" "}
                                {/* {data.customer?.gstnumber || ""} */}
                              {NumVal}
                              </p>
                              <p className=" mb-0">
                                <span style={{ fontWeight: 600 }}>Date: </span>{" "}
                                {/* {data.customer?.pannumber || ""} */}
                                {
                                  isDate
                                  ? DateConverter.ISOToDisplayFormat(
                                      DateConverter.convertToTimeZone(isDate)
                                    ).date
                                  : ""
                                }
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      {/* <div className="tm_invoice_info tm_mb20">
                        <div className="tm_invoice_seperator tm_gray_bg"></div>
                        <div className="tm_invoice_info_list">
                          <p className="tm_invoice_number tm_m0 mb-0 mt-3">
                            <b className="tm_primary_color">Invoice No: </b>{" "}
                            {data.saleno}
                          </p>
                          <p className="tm_invoice_date tm_m0  mt-3">
                            <b className="tm_primary_color"> Date: </b>{" "}
                            {data.Date}
                          </p>
                        </div>
                      </div> */}
                      {data?.estimateToId ?(
                      <table width="100%" className="pdfcontent">
                        <tbody>
                          <tr>
                            <td width="3%" className="hederTd"></td>
                            <td width="98%" className="hederTd pb-0 pt-3">
                              <p
                                style={{
                                  fontSize: "12px",
                                  lineHeight: "10px",
                                  fontWeight: "600",
                                  marginBottom: "0px",
                                }}
                              >
                                Estimation To
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td width="3%" className="hederTd"></td>
                            <td width="98%" className="hederTd">
                              <p
                                className="mb-0"
                                style={{ marginLeft: "3rem" }}
                              >
                                Name:{" "}
                                <span
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "600",
                                  }}
                                >
                                  {data?.estimateToId?.name}
                                </span>
                              </p>
                              <div
                                style={{
                                  fontSize: "12px",
                                  lineHeight: "18px",
                                  marginBottom: "0px",
                                }}
                              >
                                <p
                                  className="mb-0"
                                  style={{ marginLeft: "3rem" }}
                                >
                                  Address:{" "}
                                  <span className="fs-12 ">
                                    {[
                                      data?.estimateToId?.addressline1,
                                      data?.estimateToId?.addressline2,
                                      data?.estimateToId?.state,
                                      data?.estimateToId?.district,
                                      data?.estimateToId?.country,
                                    ]
                                      .filter(Boolean)
                                      .join(", ")}
                                    {data?.estimateToId?.pincode
                                      ? ` - ${data.estimateToId.pincode}`
                                      : ""}
                                  </span>
                                </p>
                                <p
                                  className="mb-0"
                                  style={{ marginLeft: "3rem" }}
                                >
                                  {" "}
                                  Phone:{" "}
                                  <span className="fs-12 ">
                                    {data?.estimateToId?.phone || ""}
                                  </span>
                                </p>
                                <p
                                  className="mb-0"
                                  style={{ marginLeft: "3rem" }}
                                >
                                  eMail:{" "}
                                  <span className="fs-12 ">
                                    {data?.estimateToId?.email || ""}
                                  </span>
                                </p>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      ):(
                        <p className="m-2"/>                     
                      )}
                      <table
                        className="items"
                        width="97%"
                        style={{
                          margin: "0 auto",
                          marginTop: "0px",
                          borderCollapse: "collapse",
                        }}
                        cellPadding="4"
                      >
                        <thead>
                          <tr>
                            <th
                              className="tablehead"
                              style={{
                                width: "70px",
                                textAlign: "center",
                                border: "0.5mm solid #ffffff",
                              }}
                            >
                              S.No
                            </th>
                            <th
                              className="tablehead"
                              colSpan={8}
                              style={{
                                width: "690px",
                                textAlign: "center",
                                background: "#f3f3f3",
                                border: "0.5mm solid #ffffff",
                              }}
                            >
                              Description
                            </th>

                            <th
                              className="tablehead"
                              style={{
                                width: "100px",
                                textAlign: "center",
                                border: "0.5mm solid #ffffff",
                              }}
                            >
                              Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {tableData?.map((product, index) => (
                            <tr key={index}>
                              <td
                                className="headerBody"
                                style={{
                                  textAlign: "center",
                                  fontSize: "12px",
                                  border: "0.5mm solid #ffffff",
                                }}
                              >
                                {" "}
                                {index + 1}
                              </td>
                              <td
                                className="headerBody"
                                style={{
                                  textAlign: "left",
                                  fontSize: "12px",
                                  border: "0.5mm solid #ffffff",
                                }}
                                colSpan={8}
                              >
                                <div className="text-truncate-description page-break">
                                  {product.title
                                    ? `${product.title} - ${product.description}`
                                    : "-"}
                                </div>
                                {product.hsnsac && (
                                  <div>
                                    {" "}
                                    <span className="fw-medium">
                                      HSN/SAC :{" "}
                                    </span>{" "}
                                    {product.hsnsac}
                                  </div>
                                )}
                                <div>
                                  {" "}
                                  <span className="fw-medium">Quantity : </span>
                                  {product.quantity || 0}
                                  <span className="font-11 ms-1">
                                  {`${
                                    (() => {
                                      const unitCode = product?.isSecondaryUnit
                                        ? product?.unitConfig?.secondaryUnitCode
                                        : product?.unitConfig?.primaryUnitCode;
                                      return unitCode||"" ;
                                    })()
                                  }`}
                                  </span>
                                </div>
                                <div>
                                  {" "}
                                  <span className="fw-medium">MRP : </span> ₹
                                  {CurrencyConverter.toCurrency(
                                    product.mrp || 0,
                                    "INR"
                                  )}
                                </div>
                                <div>
                                  {" "}
                                  <span className="fw-medium">
                                    Discount :{" "}
                                  </span>{" "}
                                  - ₹
                                  {CurrencyConverter.toCurrency(
                                    product.discount || 0,
                                    "INR"
                                  )}
                                </div>
                                <div>
                                  {" "}
                                  <span className="fw-medium">Price : </span> ₹
                                  {CurrencyConverter.toCurrency(
                                    product.soldprice || 0,
                                    "INR"
                                  )}
                                </div>
                                <div>
                                  <span className="fw-medium">
                                    TaxableValue:
                                  </span>{" "}
                                  ₹
                                  {CurrencyConverter.toCurrency(
                                    product.lineTotalBasePrice || 0,
                                    "INR"
                                  )}
                                </div>
                                <div>
                                  <span className="fw-medium">@</span>
                                  {product.taxpercentage}%
                                </div>
                              </td>
                              <td
                                className="headerBody"
                                style={{
                                  textAlign: "right",
                                  fontSize: "12px",
                                  border: "0.5mm solid #ffffff",
                                }}
                              >
                                ₹
                                {CurrencyConverter.toCurrency(
                                  product.baseprice || 0,
                                  "INR"
                                )}
                              </td>
                            </tr>
                          ))}

                          {data?.customer?.statecode &&
                          data?.customer?.statecode &&
                          data?.customer?.statecode !==
                            data?.customer.statecode ? (
                            <tr>
                              {/* <td
                                style={{
                                  textAlign: "right",
                                  fontSize: "12px",
                                  fontWeight: 500,
                                }}
                                colSpan="3"
                              >
                                IGST
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  fontSize: "12px",
                                  fontWeight: 500,
                                }}
                              >
                                ₹{data.igstamount || 0}
                              </td> */}
                            </tr>
                          ) : (
                            <>
                              <tr>
                                {/* <td
                                  style={{
                                    textAlign: "right",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                  }}
                                  colSpan="3"
                                >
                                  SGST
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                  }}
                                >
                                  ₹{data.sgstamount || 0}
                                </td> */}
                              </tr>
                              {/* <tr>
                                <td
                                  style={{
                                    textAlign: "right",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                  }}
                                  colSpan="3"
                                >
                                  CGST
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                  }}
                                >
                                  ₹{data.cgstamount || 0}
                                </td>
                              </tr> */}
                              <tr>
                                <td
                                  className="headerBody"
                                  style={{
                                    textAlign: "right",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    border: "0.5mm solid #ffffff",
                                  }}
                                  colSpan="9"
                                >
                                  Total
                                </td>
                                <td
                                  className="headerBody"
                                  style={{
                                    textAlign: "right",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    border: "0.5mm solid #ffffff",
                                  }}
                                >
                                  ₹
                                  {CurrencyConverter.toCurrency(
                                    data?.totalBasePrice || 0,
                                    "INR"
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  className="headerBody"
                                  style={{
                                    textAlign: "right",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    border: "0.5mm solid #ffffff",
                                  }}
                                  colSpan="9"
                                >
                                  +GST
                                </td>
                                <td
                                  className="headerBody"
                                  style={{
                                    textAlign: "right",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    border: "0.5mm solid #ffffff",
                                  }}
                                >
                                  ₹
                                  {CurrencyConverter.toCurrency(
                                    data?.totalTaxAmount || 0,
                                    "INR"
                                  )}
                                </td>
                              </tr>
                            </>
                          )}
                          <tr>
                            <td
                              style={{
                                textAlign: "right",
                                fontSize: "12px",
                                fontWeight: 500,
                                background: "#dbdbdb",
                                color: "black",
                                border: "0.5mm solid #ffffff",
                              }}
                              colSpan="9"
                            >
                              Total Amount
                            </td>
                            <td
                              className="headerBody"
                              style={{
                                textAlign: "right",
                                fontSize: "12px",
                                fontWeight: 500,
                                background: "#dbdbdb",
                                color: "black",
                                border: "0.5mm solid #ffffff",
                              }}
                            >
                              ₹
                              {CurrencyConverter.toCurrency(
                                data?.grandTotal || 0,
                                "INR"
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table width="100%" style={{ marginLeft: "10px" }}>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                padding: "8px",
                              }}
                            >
                              <div
                                className="fs-13 fw-600"
                                style={{
                                  textAlign: "left",
                                  color: "black",
                                }}
                              >
                                Note
                              </div>
                              <div className="mt-1 fs-20 ms-4">
                                1.The Estimation is valid for 5 Days from the
                                date of issue .
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                {!isProforma &&(
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: "20px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          gap: "10px",
                        }}
                      >
                        {/* Payment Info Table */}
                        <table
                          style={{
                            borderCollapse: "collapse",
                            width: "67%",
                            fontSize: "12px",
                            fontWeight: 500,
                          }}
                        >
                          <thead>
                            <tr>
                              <th
                                className="p-1"
                                colSpan={6}
                                style={{
                                  textAlign: "left",
                                  background: "#f5f5f5",
                                  border: "0.5mm solid #ffffff",
                                }}
                              >
                                <span className="fw-600 text-black">
                                  Payment Info
                                </span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td
                                className="px-1"
                                style={{
                                  textAlign: "left",
                                  background: "#f5f5f5",
                                }}
                              >
                                Account Name:
                              </td>
                              {data?.settings &&
                                data?.settings?.bankDetails && (
                                  <td colSpan={5} style={{ textAlign: "left" }}>
                                    {data.settings.bankDetails.beneficiaryName}
                                  </td>
                                )}
                            </tr>
                            <tr>
                              <td
                                className="px-1"
                                style={{
                                  textAlign: "left",
                                  background: "#f5f5f5",
                                }}
                              >
                                Account Number:
                              </td>
                              <td colSpan={5} style={{ textAlign: "left" }}>
                                {data?.settings?.bankDetails?.accountNo || "-"}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="px-1"
                                style={{
                                  textAlign: "left",
                                  background: "#f5f5f5",
                                }}
                              >
                                IFSC Code:
                              </td>
                              <td colSpan={5} style={{ textAlign: "left" }}>
                                {data?.settings?.bankDetails?.ifsc || "-"}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="px-1"
                                style={{
                                  textAlign: "left",
                                  background: "#f5f5f5",
                                }}
                              >
                                UPI ID:
                              </td>
                              <td colSpan={5} style={{ textAlign: "left" }}>
                                {data?.settings?.upiId || "-"}
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        {/* QR Code and UPI Apps Section */}
                        {data?.settings?.upiId && (
                        <div
                          style={{
                            display: "flex",
                            textAlign: "center",
                            width: "33%",
                          }}
                        >
                          <img
                            src={qrCodeDataUrl}
                            alt="QR Code"
                            style={{
                              width: "100px",
                              height: "100px",
                            }}
                          />

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              flexWrap: "wrap",
                              gap: "4px",
                            }}
                          >
                            <div
                              style={{ fontSize: "10px", marginBottom: "2px" }}
                            >
                              SCAN AND PAY <br /> WITH ANY BHIM UPI APP
                            </div>
                            <img
                              src="https://www.lyra.com/in/wp-content/uploads/sites/8/2024/10/Banner-1-1200x600.png"
                              alt="BHIM"
                              height="30"
                            />
                            <img
                              src="https://www.shutterstock.com/image-illustration/google-pay-logo-on-transparent-260nw-2311644375.jpg"
                              alt="GPay"
                              height="20"
                            />
                            <img
                              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRcgm4pm5jK3vp0VK7ZLLcH3UNY8l11hMWr2Q&s"
                              alt="PhonePe"
                              height="30"
                            />
                            <img
                              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTp2nUQCDvpxPI_8ak3xKwbITIVtTbIt-oEUA&s.png"
                              alt="Paytm"
                              height="30"
                            />
                            <img
                              src="https://www.financialexpress.com/wp-content/uploads/2019/01/amazon_pay660.jpg"
                              alt="Amazon Pay"
                              height="30"
                            />
                          </div>
                        </div>
                        )}
                      </div>
                    </div>
                 )}
                    {/* Footer */}
                    {/* <div
                      style={{
                        textAlign: "center",
                        fontSize: "12px",
                        marginTop: "0px",
                      }}
                    >
                      © 2024 Heartinz Technologies Pvt Ltd
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer d-block">
              {!isProforma &&(<>
              <div className="fw-600">PAID SUMMARY</div>
              <table
                className="items table-bordered"
                width="100%"
                cellPadding="8"
              >
                <tbody className="text-center">
                  <tr>
                    <th>CASH</th>
                    <th>CARD</th>
                    <th>ONLINE</th>
                    <th>UPI</th>
                    <th>DISCOUNT</th>
                  </tr>
                  <tr>
                    <td className="text-center">
                      ₹{toCurrency(data.cashamount || 0, "INR")}
                    </td>
                    <td className="text-center">
                      ₹{toCurrency(data.cardamount || 0, "INR")}
                    </td>
                    <td className="text-center">
                      ₹{toCurrency(data.onlineamount || 0, "INR")}
                    </td>
                    <td className="text-center">
                      ₹{toCurrency(data.upiamount || 0, "INR")}
                    </td>
                    <td className="text-center">
                      ₹{toCurrency(data.discountamount || 0, "INR")}
                    </td>
                  </tr>
                </tbody>
              </table>
             </> )}
              <button
                onClick={onClose}
                type="button"
                data-bs-dismiss="modal"
                className="btn btn-outline-secondary btn-sm text-left"
              >
                <CloseIcon iClass={"fs-15"}/> Close
              </button>
              <button
                onClick={onDone}
                className="btn btn-primary shadow-none btn-sm text-right"
                id="printreceiptbtn"
              >
                <CheckIcon iClass={"fs-15"}/> Done
              </button>
              <button
                onClick={handlePrint}
                className="btn bg-label-animal shadow-none btn-sm text-right"
                id="printreceiptbtn"
              >
                <PrinterIcon iClass={"fs-15"}/> Print{" "}
              </button>
              {download ? (
                <button
                  className="btn btn-warning btn-sm pb-0 text-right"
                  disabled
                >
                  <CircularProgress size={18} className="text-black" />
                </button>
              ) : (
                <button
                  className="btn btn-warning btn-sm text-right"
                  id="generatebillpdfbtn"
                  onClick={handleDownload}
                >
                 <DownloadIcon iClass={"fs-15"}/>
                </button>
              )}
                <button
                  className="btn btn-label-primary pb-0 text-right"
                  onClick={() => handleEdit(data)}
                  >
                  <EditIcon iClass={"fs-15"}/>
                </button>
              {/*
                    <button type="button" onclick="editsalecart()" className="btn btn-dark btn-sm text-right" fdprocessedid="iso258">
                        <i className="lni lni-pencil"></i> Edit Bill Receipt
                    </button>
                    <button onclick="printreceipt()" className="btn btn-info btn-sm text-right" id="printreceiptbtn" fdprocessedid="njp7f9">
                        <i className="lni lni-printer"></i> Print
                    </button>*/}{" "}
              {/*
               */}{" "}
              {/*
                    <button className="btn btn-warning btn-sm text-right" onclick="downloadBillPDF()" id="generatebillpdfbtn" fdprocessedid="kedald">
                        {" "}
                        <i className="bx bx-download"></i> Download PDF
                    </button> */}{" "}
              {/*
                    <button className="btn btn-success btn-sm text-right" onclick="shareBill()" fdprocessedid="l1y2of">
                        <i className="lni lni-whatsapp"></i> Share on Whatsapp
                    </button> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceTemp;